module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"user_display_name":"<b>%{name}</b>님의 리뷰입니다."}}')
  delete Component.options._Ctor
}
